module.exports = __webpack_public_path__ + "img/master-slide-02.0e93994d.jpg";